export default __webpack_public_path__ + "static/media/property_91.877a3991.png";